import React, { useContext, useState, useEffect } from 'react'
import { StateContext } from 'store/contexts'
import { animalColor, upperFirst } from 'global'
import { Box, Flex, Input, Button, AnimalIcon, Heading, Text } from 'components'

// NOTE: The SendGrid subscription widget ONLY works when display it on the initial app load, e.g. on the side screen, if load the widget later in the app, it will stop working as it's an external vanilla javascript widget
export const SubscriptionBox = () => {
  const state = useContext(StateContext)
  const hand = state.result.hand
  const currentScreen = state.screen
  const [subscriptionBox, setSubBox] = React.useState<HTMLElement | null>(null)
  const [emailValue, setEmailValue] = useState('')

  const handleHide = () => {
    subscriptionBox!.style.display = 'none'
  }

  useEffect(() => {
    const subBox = document.getElementById('oof-subscription-box')
    // if not in the results screen, set both email input the drip response msg to empty and re-enble submit button
    if (currentScreen !== 'DigestScreen') {
      setEmailValue('')
      const response = subBox!.querySelector<HTMLElement>('.drip-response')
      response!.innerHTML = ''
      const submitBtn = subBox!.querySelector<HTMLButtonElement>(
        '.drip-submit-btn'
      )
      submitBtn!.disabled = false
    }
    setSubBox(subBox)
  }, [currentScreen])

  return (
    <Box
      id='oof-subscription-box'
      // The box is set visible in the DigestScreen component when the modal is toggled.
      display='none'
      position='fixed'
      zIndex={9999}
      height='100%'
      width='100%'
      max-width='400px'
      backgroundColor={hand ? animalColor(hand.color) : 'inherit'}
    >
      <Box height='100%' padding={2}>
        <Flex width={1} height='100%' flexDirection='column'>
          {hand && (
            <Flex
              height='100%'
              flexDirection='column'
              justifyContent='flex-end'
              alignItems='center'
              padding={2}
            >
              <AnimalIcon name={hand.animal} width='100%' />
              <Heading
                as='h2'
                fontSize='32px'
                marginTop={4}
                marginBottom={3}
                textAlign='center'
              >
                Join the {upperFirst(hand.animal)} Club
              </Heading>
              <Text marginBottom={3} fontSize='16px' textAlign='center'>
                Join the {upperFirst(hand.animal)} Club for a feed of exclusive
                deals tailored to you.
              </Text>
            </Flex>
          )}
          <form
            data-drip-embedded-form=''
            data-drip-ga-event-label='Newsletter OOF'
            data-drip-tags='Newsletter, OOF'
            data-drip-confirmation='Thanks for subscribing to our newsletter!'
            data-drip-fallback='Something went wrong, please try again later!'
            style={{
              width: '100%',
            }}
            onSubmit={(e) => {
              e.preventDefault()
              return false
            }}
          >
            <Flex flexDirection='column' alignItems='center'>
              <Input
                className='drip-input'
                // styled-system clashing with styled-components input element, not sure how to fix.
                // @ts-ignore
                width='100%'
                maxWidth='290px'
                height={50}
                marginBottom={3}
                fontSize={16}
                borderRadius='23px'
                padding={2}
                border='1px solid transparent'
                placeholder='Enter your email address...'
                type='email'
                name='fields[email]'
                required
                value={emailValue}
                onChange={(e) => setEmailValue(e.target.value)}
              />
              <Button
                full
                maxWidth='290px'
                height={50}
                marginBottom={2}
                className='drip-submit-btn'
              >
                Join Now
              </Button>
              <div className='drip-response' />
            </Flex>
          </form>
          <Flex height='100%' flexDirection='column' alignItems='center'>
            <Button
              full
              maxWidth='290px'
              variant='link'
              color='rgba(18, 0, 46, 0.5)'
              onClick={() => handleHide()}
            >
              Cancel
            </Button>
          </Flex>
        </Flex>
      </Box>
    </Box>
  )
}
